export const en = {
  loginButton: 'Login',
};
